import React, { useCallback, useMemo, useEffect } from 'react'
import classNames from 'classnames'
import { useHistory, useLocation } from 'react-router-dom'

import useScrollActiveTabIntoView from '../../hooks/useScrollActiveTabIntoView'
import styles from './styles.module.scss'

export default function CupTab({ navList, showAll = true }) {
  const history = useHistory()
  const { pathname } = useLocation()

  const goToUrl = useCallback(
    url => {
      history.push(url)
    },
    [history]
  )

  const filteredNavList = useMemo(() => {
    return navList.filter(item => showAll || item.isShow)
  }, [navList, showAll])

  // Use the custom hook for scroll functionality
  const { containerRef, tabRefs, scrollToActiveTab } =
    useScrollActiveTabIntoView(filteredNavList, pathname)

  // Scroll active tab into view when pathname changes
  useEffect(() => {
    // Small delay to ensure DOM is updated
    const timeoutId = setTimeout(scrollToActiveTab, 100)
    return () => clearTimeout(timeoutId)
  }, [pathname, scrollToActiveTab])

  return (
    <div
      ref={containerRef}
      className={classNames('cupTabBorder', 'b-shadow', styles.container)}
      data-testid='cup-tab-navigation'
    >
      <ul className={styles.list}>
        {filteredNavList.map(i => {
          const isActive =
            i.to === pathname || i.to1 === pathname || i.to2 === pathname

          return (
            <li
              key={`cup-tab-${i.id}`}
              ref={el => {
                if (el) {
                  tabRefs.current[i.id] = el
                }
              }}
              onClick={() => goToUrl(i.to)}
              className={classNames(
                {
                  [styles.active]: isActive,
                },
                styles.listItem
              )}
              data-testid={`cup-tab-${i.id}`}
            >
              {i.title}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
